import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ArcIconButton, ArcStack } from '@src/core/ui';
import TerrainAware from '@src/features/order/pages/upsert-mission-page/components/terrain-aware';

// Wraps the terrain-aware chart with a hide/expand control. Collapsed, it leaves a small
// button in the map's bottom-left corner to bring the chart back.
const TerrainAwarePanel: React.FC = () => {
  const [collapsed, setCollapsed] = React.useState(false);

  if (collapsed) {
    return (
      <ArcStack position='absolute' bottom={8} left={8} zIndex={100}>
        <ArcIconButton
          size='small'
          aria-label='Show terrain awareness'
          onClick={() => setCollapsed(false)}
          sx={{ bgcolor: 'black', '&:hover': { bgcolor: 'grey.900' }, borderRadius: '4px', p: 1, opacity: 0.75}}>
          <KeyboardArrowUpIcon fontSize='small' sx={{ color: 'common.white', opacity: 1 }} />
        </ArcIconButton>
      </ArcStack>
    );
  }

  return (
    <ArcStack
      p={1}
      width='100%'
      height={260}
      zIndex={100}
      bottom={0}
      bgcolor='transparent'
      position='absolute'>
      <ArcStack position='relative' height='100%' width='100%'>
        <ArcIconButton
          size='small'
          aria-label='Hide terrain awareness'
          onClick={() => setCollapsed(true)}
          sx={{ position: 'absolute', top: 4, right: 4, zIndex: 101 }}>
          <KeyboardArrowDownIcon fontSize='small' sx={{ color: 'common.white' }} />
        </ArcIconButton>
        <TerrainAware />
      </ArcStack>
    </ArcStack>
  );
};

export default TerrainAwarePanel;
